<div class="grid grid-gutter-20 align-items-center">
  <div class="grid-item grid-sm-12">
    <div class="hidden-sm typography typography-headline grey-800 mr-16">
      Показать
    </div>

    <div class="hidden block-sm typography typography-h4 grey-800 full-width">
      Показать
    </div>
  </div>

  <div class="grid-item grid-2 grid-sm-6 grid-xs-12 min-w-256">
    <nz-date-picker
      #datePickerFromDate
      class="full-width"
      nzFormat="dd.MM.yyyy"
      nzPlaceHolder="c"
      [ngModel]="fromDate$ | async | dateBar"
      [nzDisabledDate]="disabledFromDate"
      (ngModelChange)="onChangeFromDate($event)"
      nzSuffixIcon=""
      [cleave]="datePickerFromDate"
    ></nz-date-picker>
  </div>

  <div class="grid-item grid-2 grid-sm-6 grid-xs-12 min-w-256">
    <nz-date-picker
      #datePickerToDate
      class="full-width"
      nzFormat="dd.MM.yyyy"
      nzPlaceHolder="по"
      [ngModel]="toDate$ | async | dateBar"
      [nzDisabledDate]="disabledToDate"
      (ngModelChange)="onChangeToDate($event)"
      nzSuffixIcon=""
      [cleave]="datePickerToDate"
    ></nz-date-picker>
  </div>
</div>
